import axios from "../plugins/axios.plugin";

class PublicPaymentService {
  baseServicePath = "/api/public/payment";

  showAPublicPayment(id) {
    return axios.get(`${this.baseServicePath}/show?id=${id}&properties=1`);
  }
}
export const publicPaymentService = new PublicPaymentService();
